import type { FC, ReactNode } from "react";
import { VisualChoiceGrid, type VisualChoiceOption, type VisualChoiceShape } from "@/ui/Clickable/VisualChoiceGrid";
import { AnnieStudioSection } from "./AnnieStudioSection";
import { kebab } from "./annieStudioOptions";
import type { AnnieStudioSlot } from "./annieStudioSlots";

export interface AnnieStudioPartRow {
	slot: AnnieStudioSlot;
	title: string;
	render: (labelId: string) => ReactNode;
}

interface PartRowSpec<T extends string> {
	slot: AnnieStudioSlot;
	title: string;
	value: T;
	options: VisualChoiceOption<T>[];
	onChange: (value: T) => void;
	shape: VisualChoiceShape;
	disabled: boolean;
}

/** One picker row, typed to its slot's values. */
export const partRow = <T extends string>({ slot, title, value, options, onChange, shape, disabled }: PartRowSpec<T>): AnnieStudioPartRow => ({
	slot,
	title,
	render: (labelId) => (
		<VisualChoiceGrid
			ariaLabelledBy={labelId}
			size="MD"
			shape={shape}
			disabled={disabled}
			value={value}
			onChange={onChange}
			options={options}
			dataTestId={`annie-studio-${kebab(slot)}`}
		/>
	),
});

/** The labelled picker rows for one style. */
export const AnnieStudioPartSections: FC<{ rows: AnnieStudioPartRow[] }> = ({ rows }) => (
	<>
		{rows.map((row) => (
			<AnnieStudioSection key={row.slot} title={row.title}>
				{row.render}
			</AnnieStudioSection>
		))}
	</>
);
